import { render, staticRenderFns } from "./UserWrapper.vue?vue&type=template&id=2381e90b&scoped=true&"
import script from "./UserWrapper.vue?vue&type=script&lang=js&"
export * from "./UserWrapper.vue?vue&type=script&lang=js&"
import style0 from "./UserWrapper.vue?vue&type=style&index=0&id=2381e90b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2381e90b",
  null
  
)

export default component.exports